import 'css-chunksrc/client/pages/exportsPage/timesheetReport/sort/styles.scss';export default {
  "sort": "_sort_1pqr8_1",
  "label": "_label_1pqr8_9",
  "input": "_input_1pqr8_15",
  "placeholder": "_placeholder_1pqr8_31",
  "icon": "_icon_1pqr8_39",
  "listRoot": "_listRoot_1pqr8_47",
  "list": "_list_1pqr8_47",
  "item": "_item_1pqr8_63",
  "option": "_option_1pqr8_76",
  "selected": "_selected_1pqr8_83",
  "opened": "_opened_1pqr8_96"
};